import './defines';
import {
	Component,
	toNative,
} from 'utils/vue-facing-decorator';
import {
	Prop,
	Vue,
} from 'vue-facing-decorator';
import Template from './template.vue';

@Component({
	mixins: [Template],
})
class CloneView extends Vue {
	@Prop({
		required: true,
		type: String,
	})
	public readonly productImage!: string;
}

export default toNative(CloneView);
